import * as Sentry from '@sentry/vue'

import { useIsNative } from '~/composables/usePlatform'

export default defineNuxtPlugin(nuxtApp => {
  const config = useRuntimeConfig()
  const isNative = useIsNative()

  // Only initialize in web environment
  if (!isNative) {
    try {
      Sentry.init({
        app: nuxtApp.vueApp,
        dsn: config.public.sentry.dsn,
        environment: config.public.sentry.environment,
        integrations: [Sentry.browserTracingIntegration()],
      })

      // Only provide Sentry in web environment
      return {
        provide: {
          sentry: Sentry,
        },
      }
    } catch (error) {
      console.error('Error initializing Sentry Vue:', error)
    }
  }

  // Return empty object in native environment
  return {}
})

declare module '#app' {
  interface NuxtApp {
    $sentry: typeof Sentry
  }
}

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $sentry: typeof Sentry
  }
}
